import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import GuardForm from './GuardForm';

const API_BASE_URL = 'https://ikaze-thouse-backend.vercel.app/api/v1';

const EditGuardPage = () => {
    const { id } = useParams();
    const [guard, setGuard] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchGuard = async () => {
        try {
            const res = await axios.get(`${API_BASE_URL}/guards/${id}`);
            setGuard(res.data);
            setLoading(false);
        } catch (err) {
            console.error("Error fetching guard:", err);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGuard();
    }, [id]);

    if (loading) return <p style={{ color: "white" }}>Loading...</p>;

    return (
        <GuardForm
            existingGuard={guard}
            onSuccess={() => window.location.href = '/guards'}
        />
    );
};

export default EditGuardPage;